import React from 'react';
import './ErrorDisplay.css';

const ErrorDisplay = ({ error, title = 'Error' }) => {
  return (
    <div className="error-container">
      <h2>{title}</h2>
      <p className="error-message">{error.message || error}</p>
    </div>
  );
};

export default ErrorDisplay;